import React, { useEffect, useState } from 'react';
import LeftArrow from '../../../asset/svg/leftArrow.svg';
import '../../../scss/pages/Rewards/RewardsHistory.scss';
import RewardsBGImage from '../../../asset/svg/RewardsBGImage.svg';
import TotalBalIcon from '../../../asset/svg/TotalBalIcon.svg';
import starRewardsHistory from '../../../asset/svg/starRewardsHistory.svg';
import { Box } from '@mui/system';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Backdrop, CircularProgress, Modal, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { HISTORY_REWARDS_DATA, SPOT_REWARD_AVAILABLE_COINS } from '../../../sagas/type';
import { getLocalStoreString } from '../../../utils/Helper';
import { useLocation, useNavigate } from 'react-router';
import { REWARDS_PATH, SEND_REWARDS_PATH } from '../../../utils/Constants';
import moment from 'moment';

const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

const today = new Date();
const currentYear = today.getFullYear();
const getMonth = today.getMonth();
const currentMonth = months[getMonth];
const currentShortYear = String(currentYear).slice(2);
const currentDate = today; // Set to current date instead of start of the month
const currentMonthYear = currentDate;

function RewardsHistory() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { rewardsHistoryData, spotRewardCoinsDetails } = useSelector(mapStateToProps)
    const [selectedMonthYear, setSelectedMonthYear] = useState(currentMonthYear);
    const [rewardHistory, setRewardHistory] = useState([]);
    const [reasonModal, setReasonModal] = useState(false);
    const [resonModalData, setReasonModalData] = useState('');
    const [loader, setLoader] = useState(false);
    const [loading, setLoading] = useState(false);
    const { singleUserViewedData, managerCode, spotRewardCoinsDetail, isRoute } = location?.state;

    useEffect(() => {
        if (rewardsHistoryData && rewardsHistoryData?.length) {
            setRewardHistory(rewardsHistoryData)
        }
    }, [rewardsHistoryData])


    const handleBack = () => {
        if (isRoute === 'isReward') {
            navigate(REWARDS_PATH)
        } else {
            navigate(SEND_REWARDS_PATH, { state: { singleUserViewedData: singleUserViewedData, managerCode: managerCode, spotRewardCoinsDetails: spotRewardCoinsDetail, } })
        }
    }

    const handleMonthChange = (date) => {
        setSelectedMonthYear(date);
    };

    const handleOpenReason = (reason) => {
        setReasonModal(true)
        setReasonModalData(reason)
    }

    useEffect(() => {
        setLoader(true)
        const empCode = getLocalStoreString("EmployeeCode");
        dispatch({
            type: HISTORY_REWARDS_DATA,
            payload: { managerCode: empCode },
            setLoader: setLoader,
        })
    }, [])

    useEffect(() => {
        setLoading(true)
        const empCode = getLocalStoreString("EmployeeCode");
        dispatch({
            type: SPOT_REWARD_AVAILABLE_COINS,
            payload: { managerCode: empCode },
            setLoading: setLoading,
        });
    }, [])

    return (
        <div className='RewardsHistory'>
            <div className='RewardsHistory_header'>
                <img className='RewardsHistory_header_image' src={LeftArrow} alt="" onClick={handleBack} />
                <Typography className='RewardsHistory_header_header1'>Rewards History</Typography>
            </div>
            <div className='RewardsHistory_Background-image'>
                <img src={RewardsBGImage} alt="Background" />
            </div>
            <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <div className='RewardsHistory_RewardsConstarints'>
                    <div className='RewardsHistory_RewardsConstarints_Text-cont'>
                        <Typography sx={{ color: "#FFF", fontSize: "14px", fontFamily: " 'Noto Sans', sans-serif", }} >Total Reward Balance</Typography>
                        <div className='RewardsHistory_RewardsConstarints_Text-cont_coins'>
                            <img src={TotalBalIcon} alt="Total Balance Icon" width="27px" />
                            <Typography sx={{ color: "#FFF", fontSize: "30px", fontFamily: " 'Noto Sans', sans-serif", }}>{spotRewardCoinsDetails?.totalBalance}</Typography>
                        </div>
                    </div>
                    <label htmlFor="datepicker" className='RewardsHistory_RewardsConstarints_Datepicker'>
                        <CalendarMonthIcon sx={{ color: "#FFF", fontSize: "15px", paddingRight: '1px' }} />
                        <DatePicker
                            id="datepicker"
                            selected={selectedMonthYear}
                            onChange={handleMonthChange}
                            dateFormat="MMM''dd"
                            className='RewardsHistory_RewardsConstarints_Datepicker_calendar'
                        />
                        <KeyboardArrowDownIcon sx={{ color: "#FFF", fontSize: "20px" }} />
                    </label>
                    <div className='RewardsHistory_RewardsConstarints_Card'>
                        <div className='RewardsHistory_RewardsConstarints_Card_Data'>
                            {loader ? <Backdrop
                                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer - 1 }}
                                open={loader}
                            >
                                <CircularProgress color="inherit" />
                            </Backdrop> : <>
                                {rewardHistory?.length > 0 ?
                                    <>
                                        {rewardHistory?.map((item, index) => {
                                            return (
                                                <div key={index} className='RewardsHistory_RewardsConstarints_Card_Data_rewardGroups'>
                                                    <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
                                                        <div className='RewardsHistory_RewardsConstarints_Card_Data_rewardGroups_icon'>
                                                            <img src={starRewardsHistory} width="35px" />
                                                        </div>
                                                        <div className='RewardsHistory_RewardsConstarints_Card_Data_rewardGroups_Text'>
                                                            <Typography sx={{ color: "#FFF", fontSize: "14px", fontFamily: " 'Noto Sans', sans-serif", wordBreak: "break-word", padding: " 0 0 7px 0 ", width: "100%" }}>{item?.rewardGroupName}</Typography>
                                                            <Typography sx={{ color: 'rgba(255, 255, 255, 1)', opacity: 0.54, fontWeight: 400, fontSize: '12px', lineHeight: '12px', padding: " 0 0 7px 0 ", width: "100%" }}>{moment(item?.dataOfReward).format("DD MMM")}</Typography>
                                                            <Typography sx={{ color: 'rgba(255, 255, 255, 1)', opacity: 0.54, fontWeight: 400, fontSize: '12px', lineHeight: '12px', padding: " 0 0 7px 0 ", width: "100%" }}>{item?.fullName}</Typography>
                                                            <Typography sx={{ color: 'rgba(255, 255, 255, 1)', opacity: 0.54, fontWeight: 400, fontSize: '12px', lineHeight: '12px', padding: " 0 0 7px 0 " }}>{item?.employeeCode}</Typography>
                                                        </div>
                                                    </div>
                                                    <div className='RewardsHistory_RewardsConstarints_Card_Data_rewardGroups_reason'>
                                                        <Typography sx={{ color: item?.transactionType === "REWARD_GROUP_CREDIT_MANAGERS" ? "#6FDF97" : "#F95F5F", fontSize: "14px", fontFamily: " 'Noto Sans', ", whiteSpace: "nowrap", textAlign: "center", width: "100%", fontWeight: 600 }}>{item?.transactionType === "REWARD_GROUP_CREDIT_MANAGERS" ? "+" : "-"}&nbsp;<img src={TotalBalIcon} alt="Total Balance Icon" width="10px" />&nbsp;{item?.amount}</Typography>
                                                        {item?.reason !== null && <Typography sx={{ color: "#8074FF", fontWeight: 700, fontSize: "12px", fontFamily: " 'Noto Sans', sans-serif", textAlign: "center", lineHeight: "12px", marginRight: '5px', padding: " 0 0 7px 0 ", width: "100%" }} onClick={() => handleOpenReason(item?.reason)}>Reason</Typography>}
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </> : <div className='RewardsHistory_RewardsConstarints_Card_Data_NoRecords'>
                                        <Typography sx={{ color: 'rgba(255, 255, 255, 1)', opacity: 0.54, fontWeight: 400, fontSize: '12px', lineHeight: '12px', padding: " 0 0 7px 0 " }}>No Data Found</Typography>
                                    </div>}
                            </>
                            }
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                open={reasonModal}
                onClose={() => { setReasonModal(false); setReasonModalData('') }}
                aria-labelledby="parent-modal-title"
                aria-describedby="parent-modal-description"
                sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            >
                <div className='Planner-container_filter-modal'>
                    <Box sx={{ backgroundColor: '#0B245F', borderRadius: '1rem', display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start', flexDirection: 'column', width: "100%", minHeight: "30vh" }}>
                        <HorizontalRuleIcon onClick={() => { setReasonModal(false); setReasonModalData('') }} sx={{ top: 10, left: "50%", position: "absolute", width: "30px", height: "3px", opacity: 0.4, background: "#FFF" }} />

                        <div style={{ padding: "1.5rem" }}>
                            <Typography sx={{ color: '#FFF', fontWeight: 600, fontSize: '14px', lineHeight: '12px', padding: " 0 0 7px 0 " }}>Reason</Typography>
                            <Typography sx={{ color: 'rgba(255, 255, 255, 1)', opacity: 0.54, fontWeight: 400, fontSize: '12px', lineHeight: '12px', padding: " 7px 0 7px 0 " }}>{resonModalData}</Typography>
                        </div>
                    </Box>
                </div>
            </Modal >
        </div >
    )
}

const mapStateToProps = (state) => {
    return {
        rewardsHistoryData: state.spotRewardConfig.rewardsHistoryData,
        spotRewardCoinsDetails: state.spotRewardConfig.spotRewardCoinsDetails
    }
}

export default RewardsHistory;